import ZingTouch from 'zingtouch';
import gsap from 'gsap';
import Nearby from '../shared/classes/Nearby';
import { getCardinalDirection } from '../shared/helpers/ZingTouchHelper';
import { DOM } from '../shared/helpers/Document';


(() => {
	document.addEventListener('pageLoad', () => {
		const section = DOM.qs('.section-carousel-concerts');
		if(! section ) {
			return;
		}
		
		const carousel = section.querySelector('.carousel-concerts');
		if(! carousel ) {
			return;
		}
		
		const carouselItemsContainer = carousel.querySelector('.items');
		const carouselItems = Array.from(carouselItemsContainer.querySelectorAll('.item'));
		
		const swipeEnabled = carousel.dataset.hasOwnProperty('withSwipe') ? carousel.dataset.withSwipe !== 'false' : true;
		const proximityEffect = carousel.dataset.hasOwnProperty('withProximity') ? carousel.dataset.withProximity !== 'false' : true;
		let autoplay = carousel.dataset.hasOwnProperty('autoplay') ? carousel.dataset.autoplay !== 'false' : true;
		
		const autoplayDelay = parseInt(carousel.dataset.interval || 3000);
		let _autoplayTimer = null;
		
		// whatever we do, start at [distanceThreshold.max]px from the
		// element and end at [distanceThreshold.min]px from the element.
		const distanceThreshold = {
			min: 0, 
			max: 200,
		};
		
		// translate goes from -80% to -60% (prevEl) 
		// and from 80% to 60% (nextEl)
		const translateIntervalPrev = {
			from: 0, 
			to: 15,
		};
		
		const translateIntervalNext = {
			from: 0, 
			to: -15,
		};
		
		const translateIntervalCurrent = { 
			from: 0, 
			to: 5, 
		};
		
		const opacityInterval = { 
			from: 0.2, 
			to: 1, 
		};
		
		const opacityIntervalCurrent = { 
			from: 0.7, 
			to: 1, 
		};
		
		let onprev;
		let onnext;
		let nearbyPrev;
		let nearbyNext
		
		let _index = 0;
		
		const classes = {
			prev: 'item--prev',
			next: 'item--next',
			current: 'item--current',
		};
		
		
		const _dispatchEnterEvent = (item, index) => {
			const event = new CustomEvent('carouselItemEnter', { 
				detail: { index, item },
			});
			carousel.dispatchEvent(event);
		}
		
		const videoPlay = (item, play) => {
			const video = item.querySelector('.video-thumbnail video');
			if(video) {
				play ? video.play() : video.pause();
			}
		}
		
		
		// init 
		const currentOnInit = carouselItemsContainer.querySelector('.'+ classes.current);
		if( currentOnInit ) {
			const ix = carouselItems.findIndex( item => item.classList.contains(classes.current) );
			if( ix > -1 ) {
				_dispatchEnterEvent( currentOnInit, ix );
			}
			
			videoPlay(currentOnInit, true);
		}
		else {
			_dispatchEnterEvent( carouselItems, 0 );
		}
		
		
		const _autoPlay = () => {
			if(! autoplay ) {
				return;
			}
			
			if( _autoplayTimer ) {
				clearTimeout(_autoplayTimer);
			}
	
			_autoplayTimer = setTimeout(() => {
				const nextIndex = _index + 1 >= carouselItems.length ? 0 : _index + 1;
				setIndex(nextIndex);
			}, autoplayDelay);
			
		}
		
		
		const setIndex = (index) => {
			clearTimeout(_autoplayTimer);
			if(! carouselItems[index] || index === _index ) {
				return;
			}
			
			const bullets = carousel.querySelectorAll('.bullets-nav button');
			bullets.forEach((bullet, bix) => {
				if( bix === index ) {
					return bullet.classList.add('current');
				}
				return bullet.classList.remove('current');
			});
			
			// Clear all 
			//nearbyPrev && nearbyPrev.destroy();
			//nearbyNext && nearbyNext.destroy();
			
			carouselItems.forEach(_item => {
				gsap.killTweensOf(_item);
				gsap.set(_item, { clearProps: true });
				_item.classList.remove(classes.prev, classes.next, classes.current);
				videoPlay(_item, false);
			});
			
			// Update classes 
	
			gsap.to(carouselItemsContainer, { 
				xPercent: (100 * index * -1), 
				ease: 'expo.out', 
				duration: 1,
			});
			
			if( carouselItems[index - 1] ) {
				carouselItems[index - 1].classList.add(classes.prev);
				nearbyPrev && nearbyPrev.setElement(carouselItems[index - 1]);
			}
			
			if( carouselItems[index + 1] ) {
				carouselItems[index + 1] && carouselItems[index + 1].classList.add(classes.next);
				nearbyNext && nearbyNext.setElement(carouselItems[index + 1]);
			}
			
			carouselItems[index].classList.add(classes.current);
			videoPlay(carouselItems[index], true);
			
			onprev = onnext = false;
			
			
			setTimeout(() => {
				_dispatchEnterEvent( carouselItems[index], index );
				_index = index;
				if( autoplay ) {
					_autoPlay();
				}
			}, 100);
		};
		
		
		
		const createBulletsNav = () => {
			if( carouselItems.length < 2 ) {
				return;
			}
			
			const navEl = document.createElement('ul');
			navEl.classList.add('bullets-nav');
			
			carouselItems.forEach((item, index) => {
				const btnWrap = document.createElement('li');
				const btn = document.createElement('button');
				btn.classList.add('no-ui');
				btn.addEventListener('click', () => {
					if(! btn.classList.contains(classes.current) ) {
						setIndex(index);
					}
				});
				
				if( index === _index ) {
					btn.classList.add('current');
				}
				
				btnWrap.appendChild(btn);
				navEl.appendChild(btnWrap);
			});
			
			carousel.appendChild(navEl);
		}
		
		
		/*
		* Add click event listener on each element 
		*/
		carouselItems.forEach((item, index) => {
			item.addEventListener('click', () => {
				if(! item.classList.contains(classes.current) ) {
					setIndex(index);
				}
			});
		});
		
		
		createBulletsNav();
		
		document.addEventListener('pageLeave', event => {
			autoplay = false;
			clearTimeout(_autoplayTimer);
		});
		
		
		if( autoplay ) {
			carouselItems.forEach(item => {
				item.addEventListener('mouseenter', () => {
					clearTimeout(_autoplayTimer);
				});
			});
			
			carouselItems.forEach(item => {
				item.addEventListener('mouseleave', () => {
					_autoPlay();
				});
			});
			
			_autoPlay();	
		}
		
		
		if( swipeEnabled ) {
			/*
			* Add swipe event listener on container
			*/
			const ztRegion = ZingTouch.Region(section, false, false);
			const panEvent = new ZingTouch.Pan({
				numInputs: 1,
				threshold: 50,
			});
			
			
			ztRegion.bind(carousel, panEvent, event => {
				
				const { currentDirection } = event.detail.data[0];
				const direction = getCardinalDirection(currentDirection);
				
				if( direction === 'W' || direction === 'E' ) {	
					// Within each of those special ZingTouch events, 
					// the originalEvent the browser emitted is stored.
					event.detail.events.forEach(e => e.originalEvent.preventDefault());
					const xMove = direction === 'W' ? 1 : -1;
					return setIndex(_index + xMove);
				}
			}, false);
		}
		
		
			
		
		
		/*
		* Below starts the nearby detection 
		*/
		if( proximityEffect ) {
			// Equation of a line.
			// y = mx + b 
			const lineEq = (y2, y1, x2, x1, currentVal) => {
				var m = (y2 - y1) / (x2 - x1), b = y1 - m * x1;
				return m * currentVal + b;
			};
		
		
			/* 
			* The previous element 
			*/
			nearbyPrev = new Nearby(carousel.querySelector('.'+ classes.prev), {
				onProgress: (distance) => {
					const previous = carousel.querySelector('.'+ classes.prev);
					if(! previous ) {
						onprev = false;
						return;
					}
					
					onprev = distance <= distanceThreshold.max && distance >= distanceThreshold.min;
					if ( onnext ) {
						return;
					}
				
					const tx = lineEq(
						translateIntervalPrev.from, 
						translateIntervalPrev.to, 
						distanceThreshold.max, 
						distanceThreshold.min, 
						distance
					);
					
					const o = lineEq(
						opacityInterval.from, 
						opacityInterval.to, 
						distanceThreshold.max, 
						distanceThreshold.min, 
						distance
					);
					
					gsap.to(previous, {
						x: Math.min(
							Math.max(translateIntervalPrev.from, tx), 
							translateIntervalPrev.to
						) +'%',
						duration: 1,
						overwrite: 'auto',
						ease: 'power4.easeOut',
					});
					
					
					gsap.to(previous, {
						opacity: gsap.utils.clamp(
							opacityInterval.from, 
							opacityInterval.to, 
							Math.max(o, opacityInterval.from)
						),
						duration: .5,
						overwrite: 'auto',
						ease: 'expo.easeOut',
					});
					
					
					const current = carousel.querySelector('.'+ classes.current);
					if( current ) {
						const txCurr = lineEq(
							translateIntervalCurrent.from, 
							translateIntervalCurrent.to, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						const oCurr = lineEq(
							opacityIntervalCurrent.to, 
							opacityIntervalCurrent.from, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						gsap.to(current, {
							x: Math.min(
								Math.max(translateIntervalCurrent.from, txCurr), 
								translateIntervalCurrent.to
							) +'%',
							duration: 1,
							overwrite: 'auto',
							ease: 'power4.easeOut',
						});
						
						gsap.to(current, {
							opacity: gsap.utils.clamp(
								opacityIntervalCurrent.from, 
								opacityIntervalCurrent.to, 
								Math.max(oCurr, opacityIntervalCurrent.from)
							),
							duration: .5,
							overwrite: 'auto',
							ease: 'expo.easeOut',
						});
					}
					
					const next = carousel.querySelector('.'+ classes.next);
					if( next ) {
						const txNext = lineEq(
							translateIntervalNext.from, 
							translateIntervalNext.from + 10, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						gsap.to(next, {
							x: Math.min( 
								Math.max(translateIntervalNext.from, txNext),
								translateIntervalNext.from + 10 
							) +'%',
							duration: 1,
							overwrite: 'auto',
							ease: 'power4.easeOut',
						});
					}
				}
			});
			
			
			
			/* 
		 	* The next element 
		 	*/
			
			nearbyNext = new Nearby(carousel.querySelector('.'+ classes.next), {
				onProgress: (distance) => {
					const next = carousel.querySelector('.'+ classes.next);
					if(! next ) {
						onnext = false;
						return;
					}
					
					onnext = distance <= distanceThreshold.max && distance >= distanceThreshold.min;
					if ( onprev ) {
						return;
					}
	
					
					const tx = lineEq(
						translateIntervalNext.from, 
						translateIntervalNext.to, 
						distanceThreshold.max, 
						distanceThreshold.min, 
						distance
					);
					
					const o = lineEq(
						opacityInterval.from, 
						opacityInterval.to, 
						distanceThreshold.max, 
						distanceThreshold.min, 
						distance
					);
					
					gsap.to(next, {
						x: Math.min(
							Math.max(translateIntervalNext.to, tx),
							translateIntervalNext.from
						) +'%',
						duration: 1,
						overwrite: 'auto',
						ease: 'power4.easeOut',
					});
					
					gsap.to(next, {
						opacity: gsap.utils.clamp(
							opacityInterval.from, 
							opacityInterval.to, 
							Math.max(o, opacityInterval.from)
						),
						duration: .5,
						overwrite: 'auto',
						ease: 'expo.easeOut',
					});
					
					const current = carousel.querySelector('.'+ classes.current);
					if( current ) {
						// also animate current and prevEl..
						const txCurr = lineEq(
							translateIntervalCurrent.from, 
							translateIntervalCurrent.to * -1, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						const oCurr = lineEq(
							opacityIntervalCurrent.to, 
							opacityIntervalCurrent.from, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						gsap.to(current, {
							x: Math.max(
								Math.min(translateIntervalCurrent.from, txCurr), 
								translateIntervalCurrent.to * -1 
							) +'%',
							duration: 1,
							overwrite: 'auto',
							ease: 'power4.easeOut',
						});
						
						gsap.to(current, {
							opacity: gsap.utils.clamp(
								opacityIntervalCurrent.from, 
								opacityIntervalCurrent.to, 
								Math.max(oCurr, opacityIntervalCurrent.from)
							),
							duration: .5,
							overwrite: 'auto',
							ease: 'expo.easeOut',
						});
					}
					
					const previous = carousel.querySelector('.'+ classes.prev);
					if( previous ) {
						const txPrev = lineEq(
							translateIntervalPrev.from, 
							translateIntervalPrev.from - 10, 
							distanceThreshold.max, 
							distanceThreshold.min, 
							distance
						);
						
						gsap.to(previous, {
							x: Math.max(
								Math.min(translateIntervalPrev.from, txPrev), 
								translateIntervalPrev.from - 10
							) +'%',
							duration: 1,
							overwrite: 'auto',
							ease: 'power4.easeOut',
						});
					}
				}
			});
		}
	});
})();
